import globalIP from '@/GlobelIP';
import ugr from '@/UGRoute';
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
const ClientsProtectedRoutes = () => {
  const [companydata, setCompanydata] = useState('');
  useEffect(() => {
    fetchcompdata();
  }, []);
  const fetchcompdata = async () => {
    const response = await fetch(`${globalIP}/api/company-details?populate=*`);
    const json = await response.json();
    setCompanydata(json.data[0].attributes.Type);
  };
  const isLoggedIn = sessionStorage.getItem('isActive');
  if (isLoggedIn) {
    return <Outlet />;
  } else {
    if (companydata == 'Domestic') {
      return <Navigate to={`/${ugr}/client/product`} />;
    } else {
      return <Navigate to={`/${ugr}/client/apptwo`} />;
    }
  }
};
export default ClientsProtectedRoutes;
